import { useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';

/**
 * A hook to typecheck and null check useParams. We do this because react-router
 * can never be sure of where we are calling useParams from. Even if we are sure
 * IN THIS MOMENT, in the future, a route component could be deleted or a param
 * name could change This gives us a test for that case
 */
export function useTypedParams<T extends string>(
  parameterNames: T[],
): Record<T, string> {
  const params = useParams();
  const typedParams: Record<string, string> = {};
  parameterNames.forEach((paramName) => {
    const currentParam = params[paramName];
    invariant(
      currentParam,
      `${paramName} not found in useParams. Check the parent route to make sure nothing changed`,
    );
    typedParams[paramName] = currentParam;
  });
  return typedParams;
}
